export default __webpack_public_path__ + "static/media/el16.6ceb40c6.svg";